module.exports = __webpack_public_path__ + "img/cart.d15aea50.svg";